/**
 * @fileoverview Random color strategy (default).
 * Randomly selects colors without replacement.
 */

import { IColorStrategy } from './IColorStrategy.js';
import { ColorConfig } from '../abstract/BaseTheme.js';

/**
 * Random color selection strategy.
 * Selects colors randomly without replacement until all are used, then refills.
 */
export class RandomColorStrategy implements IColorStrategy {
    /**
     * Randomly select colors for pairs.
     * @param availableColors - Array of available colors
     * @param numPairs - Number of pairs to select colors for
     * @returns Array of selected colors
     */
    selectColors(availableColors: ColorConfig[], numPairs: number): ColorConfig[] {
        const available = [...availableColors];
        const selected: ColorConfig[] = [];
        
        for (let i = 0; i < numPairs; i++) {
            // Refill if we've used all colors
            if (available.length === 0) {
                available.push(...availableColors);
            }
            
            const randomIndex = Math.floor(Math.random() * available.length);
            selected.push(available[randomIndex]);
            available.splice(randomIndex, 1);
        }
        
        return selected;
    }
}
